import type {
    ApiCareerSnapshot,
    ApiSmStateSnapshot,
} from "@bridge-applications/pb-types";

type KnownCareer = Pick<ApiCareerSnapshot, "career" | "activeJob" | "pricing">;

/** A presentation hint only. Purchases still validate their terms on the server. */
export function hasAffordableCareerQuest(
    snapshot: ApiSmStateSnapshot | null,
    userId: string | null,
    knownCareer: KnownCareer | null = null,
): boolean {
    if (userId === null || snapshot?.player.userId !== userId) return false;
    const availability = snapshot.careerAvailability;
    if (
        availability?.status !== "ready" ||
        availability.minimumVisibleQuestCost === null
    )
        return false;

    const balance = snapshot.balances.find(
        ({ currencyCode }) => currencyCode === "BEACH_COINS",
    );
    if (!balance || balance.version !== availability.balanceVersion)
        return false;

    // A purchase can update Career before the requested slot refresh arrives.
    // Do not advertise the old cards or quotes during that hand-off.
    if (knownCareer) {
        if (
            BigInt(knownCareer.career.version) >
            BigInt(availability.careerVersion)
        )
            return false;
        if (
            knownCareer.career.version === availability.careerVersion &&
            knownCareer.activeJob?.jobRunId !== availability.jobRunId
        )
            return false;
        if (knownCareer.activeJob?.jobRunId === availability.jobRunId) {
            if (
                BigInt(knownCareer.activeJob.version) >
                BigInt(availability.jobVersion)
            )
                return false;
            if (
                knownCareer.pricing?.jobRunId === availability.jobRunId &&
                (availability.pricingVersion === null ||
                    BigInt(knownCareer.pricing.pricingVersion) >
                        BigInt(availability.pricingVersion))
            )
                return false;
        }
    }

    return (
        BigInt(balance.balance) >= BigInt(availability.minimumVisibleQuestCost)
    );
}
